import { Card } from "components/atoms/Card"
import { PixelImplementationStep } from "components/molecules/PixelImplementationStep"
import { PixelWhitelist } from "components/molecules/PixelWhitelist"

export const PixelModule = () => {
    return (
        <Card className="!p-0 h-fit overflow-hidden"  headerClassName="p-4" icon="code" title="Tracking Pixel" subtitle="Easily Monitor And Identify Access To Your Site" bodyClassName="flex flex-col md:flex-row h-full w-full p-4 gap-4 overflow-scroll">
            <PixelImplementationStep />
            <PixelWhitelist />
        </Card>
    )
}